<template>
  <div class="perfil_wrapper">
    <div class="perfil-shell">
      <section class="perfil-card">
        <div class="perfil-heading">
          <div class="perfil-avatar"><b-icon icon="person-fill"></b-icon></div>
          <div class="perfil-heading-copy">
            <span class="perfil-eyebrow">Cuenta personal</span>
            <h1>Mi cuenta</h1>
            <p>Información y preferencias de acceso</p>
          </div>
        </div>
        <div class="perfil-body">
          <div class="perfil-section-title">
            <b-icon icon="person-lines-fill"></b-icon>
            <span>Información personal</span>
          </div>
          <div class="perfil-details">
            <div class="perfil-detail"><span class="detail-label">Primer
                nombre</span><strong>{{ user.data.primer_nombre }}</strong></div>
            <div class="perfil-detail"><span class="detail-label">Segundo
                nombre</span><strong>{{ user.data.segundo_nombre }}</strong></div>
            <div class="perfil-detail"><span class="detail-label">Primer
                apellido</span><strong>{{ user.data.primer_apellido }}</strong></div>
            <div class="perfil-detail"><span class="detail-label">Segundo
                apellido</span><strong>{{ user.data.segundo_apellido }}</strong></div>
            <div class="perfil-detail"><span class="detail-label">Correo
                electrónico</span><strong>{{ user.data.email }}</strong></div>
            <div class="perfil-detail"><span
                class="detail-label">Documento</span><strong>{{ user.data.numero_documento }}</strong></div>
          </div>
          <div class="perfil-section-title sede-section-title">
            <b-icon icon="geo-alt-fill"></b-icon>
            <span>Sede activa</span>
          </div>
          <div class="sede-panel" v-if="sede && sede.nombre">
            <div class="sede-name-wrap"><span class="sede-status-dot"></span><strong>{{ sede.nombre }}</strong></div>
            <b-button class="sede-action" size="sm" variant="success" v-if="puedeCambiarSede"
              @click="iniciarCambiarSede()">
              <b-icon icon="arrow-left-right" class="mr-1"></b-icon>
              Cambiar sede
            </b-button>
          </div>
        </div>
      </section>
      <CambiarSedeModal ref="cambiarSedeModal"></CambiarSedeModal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CambiarSedeModal from '@/components/CambiarSedeModal';

export default {
  name: 'perfil',
  components: {
    CambiarSedeModal
  },
  methods: {
    iniciarCambiarSede() {
      this.$refs.cambiarSedeModal.abrir()
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      sede: state => state.auth.sede,
    }),
    puedeCambiarSede() {
      return !!(this.user && this.user.data && this.user.data.sedes_permitidas && this.user.data.sedes_permitidas.length)
    }
  }
}
</script>

<style scoped>
.perfil_wrapper {
  min-height: calc(100vh - 180px);
  padding: 42px 20px 56px;
  background: #f4f7fb;
}

.perfil-shell {
  max-width: 920px;
  margin: 0 auto;
}

.perfil-card {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e3eaf2;
  border-radius: 16px;
  box-shadow: 0 14px 36px rgba(20, 56, 92, 0.09);
}

.perfil-heading {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px 42px;
  background: linear-gradient(120deg, #0d4e8c 0%, #1469a5 55%, #0b315c 100%);
}

.perfil-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 84px;
  width: 84px;
  height: 84px;
  color: #0d4e8c;
  font-size: 2rem;
  background: #ffffff;
  border: 5px solid rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  box-shadow: 0 5px 16px rgba(8, 64, 121, 0.2);
}

.perfil-heading-copy {
  min-width: 0;
}

.perfil-eyebrow {
  display: block;
  margin-bottom: 4px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}

.perfil-heading h1 {
  margin: 0;
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: 700;
}

.perfil-heading p {
  margin: 4px 0 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.9rem;
}

.perfil-body {
  padding: 2rem;
}

.perfil-section-title {
  display: flex;
  align-items: center;
  gap: 9px;
  padding-bottom: 12px;
  color: #243b53;
  font-size: 0.92rem;
  font-weight: 700;
  border-bottom: 1px solid #e8eef5;
}

.perfil-section-title svg {
  color: #1481a6;
}

.perfil-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px 30px;
  margin: 8px 0 32px;
}

.perfil-detail {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  padding: 15px 0;
  border-bottom: 1px solid #eef2f6;
}

.detail-label {
  color: #8493a5;
  font-size: 0.73rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.perfil-detail strong {
  overflow-wrap: anywhere;
  color: #263b53;
  font-size: 0.96rem;
  font-weight: 600;
}

.sede-section-title {
  margin-bottom: 14px;
}

.sede-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 16px 18px;
  background: #f5fafc;
  border: 1px solid #dcecf2;
  border-radius: 10px;
}

.sede-name-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: #194563;
}

.sede-name-wrap strong {
  overflow-wrap: anywhere;
}

.sede-status-dot {
  flex: 0 0 9px;
  width: 9px;
  height: 9px;
  background: #22a06b;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(34, 160, 107, 0.12);
}

.sede-action {
  flex: 0 0 auto;
  border-radius: 6px;
}

.modal-sede-label {
  display: block;
  margin-bottom: 7px;
  color: #34495e;
  font-weight: 600;
}

@media (max-width: 576px) {
  .perfil_wrapper {
    padding: 24px 12px 36px;
  }

  .perfil-heading {
    align-items: center;
    gap: 13px;
    padding: 18px 20px;
  }

  .perfil-avatar {
    flex-basis: 62px;
    width: 62px;
    height: 62px;
    font-size: 1.45rem;
  }

  .perfil-heading h1 {
    font-size: 1.4rem;
  }

  .perfil-heading p {
    font-size: 0.78rem;
  }

  .perfil-body {
    padding: 1rem;
  }

  .perfil-details {
    display: block;
    margin-bottom: 26px;
  }

  .perfil-detail {
    padding: 12px 0;
  }

  .sede-panel {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }

  .sede-action {
    width: 100%;
  }
}
</style>